import SmoothScroll from "@/components/SmoothScroll";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import HowItWorks from "@/components/HowItWorks";
import Benefits from "@/components/Benefits";
import Faq from "@/components/Faq";
import OrderForm from "@/components/OrderForm";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="bg-[#F9F6F0]">
            <SmoothScroll />
            <Navigation />
            <Hero />
            <EditorialMarquee />
            <HowItWorks />
            <Benefits />
            <Faq />
            <OrderForm />
            <Footer />
            <WhatsAppFab />
        </main>
    );
}
